import { useContext } from 'react';
import { useCreateMachine } from 'fsm';
import { machine } from './machine';
import { SmartPropertyTemplatesContext } from './context';
import { COMPANY_TYPE_ID } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const propertyKindMap = {
  text: 'singleLineText',
  number: 'number',
  date: 'date',
  checkbox: 'singleCheckbox',
  file: 'file',
  booleancheckbox: 'singleCheckbox',
  phonenumber: 'phoneNumber',
  radio: 'radio',
  select: 'dropdownSelect',
  textarea: 'multiLineText',
  calculation_equation: 'calculation',
  calculation_rollup: 'rollup',
  calculation_score: 'score',
  calculation_read_time: 'calculation',
  unknown: 'singleLineText',
  html: 'richText'
};
export const SmartPropertyTemplatesProvider = ({
  children,
  onUseTemplate
}) => {
  const initialContext = {
    errorId: null,
    isLoaded: false,
    onUseTemplate,
    templates: [],
    templatesForDisplay: []
  };
  const SmartPropertyTemplatesMachine = useCreateMachine(machine, {
    initialContext
  });
  return /*#__PURE__*/_jsx(SmartPropertyTemplatesContext.Provider, {
    value: SmartPropertyTemplatesMachine,
    children: children
  });
};
export function useSmartPropertyTemplates() {
  const context = useContext(SmartPropertyTemplatesContext);
  if (!context) {
    throw new Error('useSmartPropertyTemplates must be used within a SmartPropertyTemplatesProvider');
  }
  const {
    state,
    send
  } = context;
  const {
    onUseTemplate
  } = state.context;
  const onCreateTemplate = template => {
    onUseTemplate({
      objectTypeId: template === null || template === void 0 ? void 0 : template.objectTypeId,
      initialPropertyConfig: {
        label: {
          value: template === null || template === void 0 ? void 0 : template.propertyLabel
        },
        options: {
          value: template === null || template === void 0 ? void 0 : template.options
        },
        propertyKind: {
          value: propertyKindMap[template === null || template === void 0 ? void 0 : template.fieldType]
        }
      },
      initialSmartPropertyConfig: {
        promptQuestion: {
          value: template === null || template === void 0 ? void 0 : template.enrichmentQuestion
        },
        dataSources: {
          value: [template === null || template === void 0 ? void 0 : template.dataSource]
        }
      }
    }).catch(() => {});
  };
  const onCreateProperty = (objectTypeId = COMPANY_TYPE_ID) => {
    onUseTemplate({
      objectTypeId
    }).catch(() => {});
  };
  return {
    hasError: state.matches('error'),
    isLoading: state.hasTag('loading'),
    onCreateTemplate,
    onCreateProperty,
    onRefresh: () => send('REFRESH'),
    onRetry: () => send('RETRY'),
    templates: state.context.templatesForDisplay
  };
}